export const LOGIN = "LOGIN";
export const SIGNIN = "SIGNIN";
export const LOGOUT = "LOGOUT";
export const APPS_LOADING = "APPS_LOADING";
export const FETCH_USER_APPS = "FETCH_USER_APPS";
export const FETCH_APPS = "FETCH_APPS";
export const FETCH_APPS_ERROR = "FETCH_APPS_ERROR";
export const SEARCH = "SEARCH";
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const SELECT_PROJECT = "SELECT_PROJECT";
export const FETCH_PROJECTS_ERROR = "FETCH_PROJECTS_ERROR";
export const SET_PROJECTS = "SET_PROJECTS";
export const SET_FLAGS = "SET_FLAGS";
export const UPDATE_CREDENTIAL = "UPDATE_CREDENTIAL";
export const FETCH_SERVICEAREA = "FETCH_SERVICEAREA";
export const FETCH_ROLES = "FETCH_ROLES";
export const FETCH_ENTERPRISE_USERS = "FETCH_ENTERPRISE_USERS";
export const FETCH_PROJECT_ASSIGNMENTS = "FETCH_PROJECT_ASSIGNMENTS";
export const FETCH_UNITS_CONFIG = "FETCH_UNITS_CONFIG";
export const FETCH_PROJECT_UNITS_CONFIG = "FETCH_PROJECT_UNITS_CONFIG";
export const CLEAR_PROJECT_UNITS_CONFIG = "CLEAR_PROJECT_UNITS_CONFIG";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_PROJECT_UNITS_RAW = "FETCH_PROJECT_UNITS_RAW";
export const SHOW_ALERT = "SHOW_ALERT";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const CLEAR_ALERT = "CLEAR_ALERT";
export const CLEAR_SNACKBAR = "CLEAR_SNACKBAR";
export const ASSIGN_ROLE_TO_USER = "ASSIGN_ROLE_TO_USER";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const SET_AFTER_RELOAD = "SET_AFTER_RELOAD";
export const FETCH_ALL_SERVICEAREA = "FETCH_ALL_SERVICEAREA";
export const FETCH_WORKFLOW_STATUS = "FETCH_WORKFLOW_STATUS";
export const FETCH_SERVICEAREA_FEATURES = "FETCH_SERVICEAREA_FEATURES";
export const FETCH_ASSET_GROUPS = "FETCH_ASSET_GROUPS";
export const FETCH_ASSET_TYPES = "FETCH_ASSET_TYPES";
export const FETCH_INTELLI_FIBER_ROLES = "FETCH_INTELLI_FIBER_ROLES";
export const FETCH_INTELLI_FIBER_USER_ROLES = "FETCH_INTELLI_FIBER_USER_ROLES";
export const FETCH_PROJECT_USER_ROLES = "FETCH_PROJECT_USER_ROLES";
export const FETCH_PERMISSIONS = "FETCH_PERMISSIONS";
export const FETCH_ROLE_PERMISSIONS = "FETCH_ROLE_PERMISSIONS";
export const SHOW_CONFIRMATION = "SHOW_CONFIRMATION";
export const FETCH_USERROLES = "FETCH_USERROLES";
export const UPDATE_USERROLES = "UPDATE_USERROLES";
export const CREATE_USERROLES = "CREATE_USERROLES";
export const DELETE_USERROLES = "DELETE_USERROLES";
export const CREATE_CLIENTPROJECTS = "CREATE_CLIENTPROJECTS";
export const CREATE_USERPROJECTS = "CREATE_USERPROJECTS";
export const DELETE_USERPROJECTS = "DELETE_USERPROJECTS";
export const DELETE_CLIENTPROJECTS = "DELETE_CLIENTPROJECTS";
export const FETCH_PHASES = "FETCH_PHASES";
